var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8646 13.9238H18.0871H18.087V0.14618C17.4038 0.0572422 16.7073 0.0107422 16 0.0107422C15.2927 0.0107422 14.5962 0.0572422 13.9131 0.14618V13.9237V13.9237H0.135438C0.0465 14.6069 0 15.3033 0 16.0107C0 16.7182 0.0465 17.4146 0.135438 18.0977H13.9129H13.913V31.8753C14.5962 31.9642 15.2927 32.0107 16 32.0107C16.7073 32.0107 17.4038 31.9643 18.0869 31.8753V18.0978V18.0977H31.8646C31.9535 17.4146 32 16.7182 32 16.0107C32 15.3033 31.9535 14.6069 31.8646 13.9238V13.9238Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngland);
export default __webpack_public_path__ + "static/media/england.7652243a.svg";
export { ForwardRef as ReactComponent };